import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type InviteUsersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.InviteUsersInput;
}>;

export type InviteUsersMutationResult = { __typename?: 'Mutation' } & {
  inviteUsers?: GraphQLTypes.Maybe<
    { __typename?: 'InviteUsersPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const InviteUsersDocument = /*#__PURE__*/ gql`
  mutation inviteUsers($input: InviteUsersInput!) {
    inviteUsers(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useInviteUsersMutation__
 *
 * To run a mutation, you first call `useInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersMutation, { data, loading, error }] = useInviteUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersMutation(
  baseOptions?: Apollo.MutationHookOptions<InviteUsersMutationResult, InviteUsersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<InviteUsersMutationResult, InviteUsersMutationVariables>(InviteUsersDocument, options);
}
export type InviteUsersMutationHookResult = ReturnType<typeof useInviteUsersMutation>;
